import { createGeneratedWalkthroughTemplate, createArtifactStepsFromWalkthroughTemplate } from './walkthrough-template';
import {
    createGeneratedAnnouncementTemplate,
    createArtifactStepsFromAnnouncementTemplate,
} from './announcment-template';
import { createArtifactStepFromEmbeddedTemplate, createGeneratedEmbeddedTemplate } from './embedded-template';
import { environmentBucket } from '@/settings/environment.utils';
import { createArtifactStepsFromMobileAnnouncementTemplate } from './mobile-step-template';
import { createGeneratedMobileAnnouncementTemplate } from './mobile-announcement-template';
import { i18n_t as $t } from '@utils/i18n';

export const TEMPLATE_TYPES = {
    WALKTHROUGH: 'walkthrough',
    ANNOUNCEMENT: 'announcement',
    EMBEDDED: 'embeddedBanner',
    MOBILE_ANNOUNCEMENT: 'mobileAnnouncement',
};

const walkthroughTemplate = {
    name: 'Walkthrough',
    subtext: $t('aiTemplate.walkThrough'),
    id: TEMPLATE_TYPES.WALKTHROUGH,
    type: ['web', 'guide'],
    active: true,
    readOnly: true,
    isAiTemplate: true,
    previewHTML: `<div style="width: 167px"><img src="https://${environmentBucket(
        true,
    )}/img/layout-chooser/ai-layout-walkthrough-svg-background.svg" alt="" style="width: 100%"/></div>`,
    supportedPlatforms: {
        web: true,
        mobile: false,
    },
    createArtifactSteps: createArtifactStepsFromWalkthroughTemplate,
    getGeneratedTemplateBlocks: createGeneratedWalkthroughTemplate,
};

const announcementTemplate = {
    name: 'Announcement',
    subtext: $t('aiTemplate.announcement'),
    id: TEMPLATE_TYPES.ANNOUNCEMENT,
    type: ['web', 'guide'],
    active: true,
    readOnly: true,
    isAiTemplate: true,
    previewHTML: `<div style="width: 167px"><img src="https://${environmentBucket(
        true,
    )}/img/layout-chooser/ai-layout-announcement-svg-background.svg" alt="" style="width: 100%"/></div>`,
    supportedPlatforms: {
        web: true,
        mobile: false,
    },
    createArtifactSteps: createArtifactStepsFromAnnouncementTemplate,
    getGeneratedTemplateBlocks: createGeneratedAnnouncementTemplate,
};

const embeddedTemplate = {
    name: 'Embedded banner',
    subtext: $t('aiTemplate.embeddedBanner'),
    id: TEMPLATE_TYPES.EMBEDDED,
    type: ['web', 'guide'],
    active: true,
    readOnly: true,
    isAiTemplate: true,
    attributes: { isEmbeddedLayout: true },
    previewHTML: `<div style="width: 167px"><img src="https://${environmentBucket(
        true,
    )}/img/layout-chooser/ai-layout-embedded-banner-svg-background.svg" alt="" style="width: 100%"/></div>`,
    supportedPlatforms: {
        web: true,
        mobile: false,
    },
    createArtifactSteps: createArtifactStepFromEmbeddedTemplate,
    getGeneratedTemplateBlocks: createGeneratedEmbeddedTemplate,
};

export const mobileAnnouncementTemplate = {
    name: 'Announcement',
    subtext: $t('aiTemplate.announcement'),
    id: TEMPLATE_TYPES.MOBILE_ANNOUNCEMENT,
    type: ['mobile', 'guide'],
    active: true,
    isAiTemplate: true,
    readOnly: true,
    previewHTML: `<div style="width: 167px"><img src="https://${environmentBucket(
        true,
    )}/img/layout-chooser/ai-layout-mobile-annoucement-svg-background.svg" alt="" style="width: 100%"/></div>`,
    supportedPlatforms: {
        web: false,
        mobile: true,
    },
    createArtifactSteps: createArtifactStepsFromMobileAnnouncementTemplate,
    getGeneratedTemplateBlocks: createGeneratedMobileAnnouncementTemplate,
};

export const aiTemplates = [walkthroughTemplate, announcementTemplate, mobileAnnouncementTemplate, embeddedTemplate];

export { canUseAIGuideEditor } from '../utils/ai-template-utils';

export const aiTemplatesMap = aiTemplates.reduce((templateMap, template) => {
    templateMap[template.id] = template;

    return templateMap;
}, {});
